module.exports = __webpack_public_path__ + "img/hu.685d7c24.svg";